import { render, staticRenderFns } from "./RequestOffer.vue?vue&type=template&id=6b04f7ac&"
import script from "./RequestOffer.vue?vue&type=script&lang=ts&"
export * from "./RequestOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports